module.exports = __webpack_public_path__ + "img/1080_01.01c73e55.jpg";